import { I04CALCULGSIMP_State } from '@batical/types/src'

const I04CALCULGSIMP: I04CALCULGSIMP_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  umurext: 'murs_1',
  vitrage: 'vitrage_1',
  plafond: 'plafond_1',
  plancher: 'plancher_1',
  configuration: 'config_1',
  res_coeffDepVol: 0.0,
  mode: 'none',
  calcul_code: 'I04CALCULGSIMP'
}

export default I04CALCULGSIMP
